import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export { ConnectionKeepAlive };

// IIS closes an idle keep-alive connection after about 2 minutes. Chrome can
// still try to reuse that socket, and the next API call then sits in
// "Stalled" until the dead connection times out. Ping well inside that window.
// This is not user activity and does not reset the logout timer.
const PING_INTERVAL_MS = 45000;
const MIN_GAP_MS = 5000;

function ConnectionKeepAlive() {
    const user = useSelector(state => state.auth.user);

    useEffect(() => {
        if (!user || !process.env.REACT_APP_API_URL) {
            return undefined;
        }

        const url = `${process.env.REACT_APP_API_URL}/Health`;
        let timerId = 0;
        let lastPing = 0;

        const ping = () => {
            if (document.visibilityState === 'hidden') {
                return;
            }

            const now = Date.now();
            if (now - lastPing < MIN_GAP_MS) {
                return;
            }

            lastPing = now;
            fetch(url, { method: 'GET', cache: 'no-store' }).catch(() => undefined);
        };

        ping();
        timerId = window.setInterval(ping, PING_INTERVAL_MS);

        const onVisible = () => {
            if (document.visibilityState === 'visible') {
                ping();
            }
        };

        document.addEventListener('visibilitychange', onVisible);
        window.addEventListener('focus', onVisible);

        return () => {
            window.clearInterval(timerId);
            document.removeEventListener('visibilitychange', onVisible);
            window.removeEventListener('focus', onVisible);
        };
    }, [user]);

    return null;
}
